import React from 'react';
import { AppBar, Typography, IconButton, Toolbar, Box, Avatar, Chip, Button } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

export default function AppBarDialog({
    handleClose,
    cliente,
    preparar
}){
    return(
        <AppBar
        elevation={4}
        sx={{
          position: "relative",
          background: "linear-gradient(135deg, #164e63 0%, #0c3a47 100%)",
        }}
      >
        <Toolbar
          sx={{
            minHeight: 76,
            px: 3,
            gap: 2,
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{
              bgcolor: "rgba(255,255,255,.08)",
              "&:hover": {
                bgcolor: "rgba(255,255,255,.16)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>

          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              gap: 2,
              overflow: "hidden",
            }}
          >
            <Avatar
              sx={{
                bgcolor: "rgba(255,255,255,.15)",
                width: 46,
                height: 46,
              }}
            >
              <PersonOutlineIcon />
            </Avatar>

            <Box sx={{ overflow: "hidden" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: "#fff",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {cliente?.razon_social}
                </Typography>

                <Chip
                  label={`CUIT ${cliente?.cuit}`}
                  size="small"
                  sx={{
                    bgcolor: "rgba(255,255,255,.15)",
                    color: "#fff",
                    fontWeight: 500,
                    border: "1px solid rgba(255,255,255,.25)",
                    "& .MuiChip-label": {
                      px: 1.2,
                    },
                  }}
                />
              </Box>

              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,.82)",
                  mt: 0.3,
                }}
              >
                Percepciones Ingresos Brutos • Inscripciones / CM05
              </Typography>
            </Box>
          </Box>

          {/* Guardar */}
          <Button
            color="inherit"
            variant="contained"
            startIcon={<SaveOutlinedIcon />}
            onClick={preparar}
            sx={{
              bgcolor: "rgba(255,255,255,.14)",
              color: "#fff",
              fontWeight: 600,
              px: 2.5,
              "&:hover": {
                bgcolor: "rgba(255,255,255,.22)",
              },
            }}
          >
            Guardar
          </Button>
        </Toolbar>
      </AppBar>
    )
}